import { Box, Button, MenuItem, Modal, Stack, Typography } from "@mui/material";
import { GenericInput } from "../../components/inputs/GenericInput";
import { useEffect, useRef, useState } from "react";
import { funcNamePattern } from "./Transformer";
import { openPopup } from "../../stateManagement/actions/popupActions";


type ModalState = "create" | "edit" | "none";

export default function UnregisteredFunctions(props:{
  unRegFuncMap:Map<string,string>,
  setUnRegFuncMap:React.Dispatch<React.SetStateAction<Map<string, string>>>
}) {
  
  const functionsMap = props.unRegFuncMap;
  const setFunctionsMap = props.setUnRegFuncMap;

  const [state, setState] = useState<ModalState>("none");
  
  function onSave(key: string, val: string) {    
    setFunctionsMap(new Map(functionsMap).set(key, val));
  }

  const handleChange = (state: ModalState) => {
    setState(state);
  };
  const handleClose = () => {
    setState("none");
  };

  const open = state === "create" || state === "edit";
  const isEditing = state === "edit";

  return (
    <div>
      <Button variant="outlined" color="primary" style={{marginRight:"10px"}} onClick={() => handleChange("create")}>Create</Button>
      <Button variant="outlined" color="primary" style={{marginRight:"10px"}} onClick={() => handleChange("edit")}>Edit</Button>

      <Modal
        open={open}
        onClose={handleClose}
      >
        <Stack
          sx={{
            backgroundColor: "#ffffff",
            position: "absolute",
            left: "50%",
            top: "20%",
            transform: "translate(-50%, -20%)",
            width: "40vw",
            minWidth: "300px",
            borderRadius: "10px",
          }}
          paddingY={3}
          paddingX={4}
          spacing={1}
        >
          <Typography variant="h6" marginBottom={2}>
              {isEditing ? "Edit Unregistered Function" : "Create Unregistered Function"}
          </Typography>
          <NewEditFunction
            functionMap={functionsMap}
            onSave={onSave}
            onClose={handleClose}
            isEditing={isEditing}
          />
        </Stack>
      </Modal>
    </div>
  );
}

function NewEditFunction(props: {
  functionMap: Map<string, string>;
  onSave: (k: string, v: string) => void;
  onClose: () => void;
  isEditing: boolean;
}) {
  const functionMap = props.functionMap;

  const [functionBody, setFunctionBody] = useState<string>("");
  const selectedFunction = useRef<string>("");

  useEffect(() => {
    setFunctionBody(functionMap.get(selectedFunction.current) || "");
  }, [functionMap]);

  return (
    <>
      {props.isEditing && (
        <GenericInput
          textFieldInputProps={{
            select: true,
            label: "Select Function",
            value: selectedFunction.current,
            children: Array.from(functionMap.keys()).map((s: string) => (
              <MenuItem key={s} value={s}>
                {s}
              </MenuItem>
            )),
            onChange: (e) => {
              selectedFunction.current = e.target.value;
              setFunctionBody(functionMap.get(selectedFunction.current) || "");
            },
          }}
        />
      )}
      
      <GenericInput
        textFieldInputProps={{
          value: functionBody,
          multiline: true,
          minRows: 10,
          maxRows: 20,
          label: "Function Body",
          onChange: (e) => {
            setFunctionBody(e.target.value);
          },
        }}
      ></GenericInput>
      
      <Box display={"flex"} justifyContent={"flex-end"}>
        <Button
          variant="outlined"
          style={{ marginRight: "10px" }}
          onClick={props.onClose}
        >
          Close
        </Button>
        <Button variant="outlined" onClick={handleSave}>
          Save
        </Button>
      </Box>
    </>
  );

  function handleSave() {
    const match = functionBody.match(funcNamePattern) || [];
    if (isUndefinedorEmpty(match) || match.length !== 5) {
      openPopup('Alert',
        "Function Body should follow the pattern function <function_name> (parameter1, parameter2, ...) {}"
      );
      return;
    }

    const funcName = match[1];

    //  && isUndefinedorEmpty(unregFunctionMapStore.get(functionInfo.id))) { // check if function name already exists in registered functions
    if(!props.isEditing && !isUndefinedorEmpty(props.functionMap.get(funcName.trim())) ){   
      openPopup('Alert',"Function Name should not match with registered functions")
      return;
    }

    if(props.isEditing && selectedFunction.current !== funcName){
      openPopup('Alert',"Function Name should not be changed while editing")
      return
    }
    openPopup('Success',`Function ${props.isEditing ? "Edited" : "Created"} Successfully`)
    props.onSave(funcName, functionBody);
    props.onClose();
  }
}

export function isUndefinedorEmpty(param: any):boolean {
  if (param === null || param === undefined || param === "" || param === "null") {
    return true;
  }
  return false;
}
